
import React from 'react';
import { useProfile } from './ProfileContext';
import { profileSteps } from './ProfileSteps';
import { Button } from "@/components/ui/button";

interface ProfileStepperProps {
  className?: string;
}

const ProfileStepper: React.FC<ProfileStepperProps> = ({ className }) => {
  const { currentStep, lastSaved, setCurrentStep } = useProfile();

  const handleStepClick = (stepId: number) => {
    setCurrentStep(stepId);
  };

  return (
    <div className={className}>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Investor Profile Setup</h1>
        <span className="text-[#9E7C47]">{currentStep} of {profileSteps.length}</span>
      </div>
      
      {/* Progress Bar */}
      <div className="w-full bg-[#9E7C47]/10 rounded-full h-2.5">
        <div 
          className="bg-[#9E7C47] h-2.5 rounded-full transition-all" 
          style={{ width: `${(currentStep / profileSteps.length) * 100}%` }}
        ></div>
      </div>
      
      {/* Steps */}
      <div className="hidden md:flex justify-between mt-2">
        {profileSteps.map((step) => (
          <Button
            key={step.id}
            variant="ghost"
            className={`text-xs p-1 h-auto ${
              step.id <= currentStep 
                ? 'text-[#9E7C47] hover:text-[#9E7C47] hover:bg-[#9E7C47]/10' 
                : 'text-white/50 hover:text-white/70 hover:bg-white/5'
            }`}
            onClick={() => handleStepClick(step.id)}
          >
            {step.name}
          </Button>
        ))}
      </div>
      
      {/* Last saved indicator */}
      {/* {lastSaved && (
        <div className="text-xs text-white/50 mt-2 text-right">
          Last saved at {lastSaved.toLocaleTimeString()}
        </div>
      )} */}
    </div>
  );
};

export default ProfileStepper;
